jQuery(document).ready(function () {
    var $ = jQuery;

    // ====================
    // Ajax add / remove favorites
    // Shows popup with title
    // ====================
    

    var editFavorites = function(id, status){
        $.ajax({
            type        : "POST",
            dataType    : "html",
            data        : {
              id: id,
              status: status,
            },
            url         : templateUrl + "/functions/update-favorites.php",
            success     : function(data){
                $('.favorite-id-' + id).html(data);
            },
            error     : function(jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
            }
        });
    }; // END getMovies

    $(document).on("click", '.org-card__favorite', function(event) {
        var id = $(this).val();
        var status = $(this).hasClass('org-card__favorite--filled');
        $('body').append($('<div />', {
        "class": 'favorite-box favorite-id-' + id,
        text: "Oppdaterer..."}));

        editFavorites(id, status);

        $(this).toggleClass('org-card__favorite--filled');
    });

    $('#searchResultGridView').on('click', function () {
      $('.favorites__org-card').removeClass('org-card__list');
      $('.favorites__org-card').addClass('org-card__grid');
    })
    $('#searchResultListView').on('click', function () {
      $('.favorites__org-card').removeClass('org-card__grid');
      $('.favorites__org-card').addClass('org-card__list');
    })
});
